// Bridge between the nuts.com-style <select> quantity dropdown on /cart and
// Dawn's CartItems web component. Dawn's validateQuantity() reads .step/.max
// as element properties, which exist on <input> but not <select>, so it would
// drop into the step-error branch and then call event.target.select() — which
// crashes on a <select>. We intercept the change here, call updateQuantity
// directly, and stop propagation so the validator never sees the event.
(function () {
  function handleChange(event) {
    const select = event.target;
    if (!select.matches('.epi-qty-select__field')) return;

    const cartItems = select.closest('cart-items') || select.closest('cart-drawer-items');
    if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

    event.stopImmediatePropagation();

    const index = select.dataset.index;
    const quantity = parseInt(select.value, 10);
    const variantId = select.dataset.quantityVariantId;

    cartItems.updateQuantity(index, quantity, event, 'updates[]', variantId);
  }

  // Capture phase so we run before CartItems' debounced 'change' listener
  document.addEventListener('change', handleChange, true);
})();
